<template>
    <!-- 弹幕轮播滚动 -->
    <div class="rollingBarrage">
        <div class="reviews-container">
          <div class="reviews-scroll-wrapper">
            <!-- 第一行 -->
            <div class="reviews-row reviews-row-1" ref="reviewsRow1">
              <div class="review-item" v-for="(review, index) in getRowReviews(0)" :key="`row1-${index}`">
                <div class="review-avatar">
                  <img :src="getAvatarImage(index)" :alt="review.name">
                </div>
                <div class="review-content">
                  <h4>{{ review.name }}</h4>
                  <p>"{{ review.content }}"</p>
                </div>
              </div>
            </div>
            
            <!-- 第二行 -->
            <div class="reviews-row reviews-row-2" ref="reviewsRow2">
              <div class="review-item" v-for="(review, index) in getRowReviews(1)" :key="`row2-${index}`">
                <div class="review-avatar">
                  <img :src="getAvatarImage(index + 8)" :alt="review.name">
                </div>
                <div class="review-content">
                  <h4>{{ review.name }}</h4>
                  <p>"{{ review.content }}"</p>
                </div>
              </div>
            </div>
            
            <!-- 第三行 -->
            <div class="reviews-row reviews-row-3" ref="reviewsRow3">
              <div class="review-item" v-for="(review, index) in getRowReviews(2)" :key="`row3-${index}`">
                <div class="review-avatar">
                  <img :src="getAvatarImage(index + 16)" :alt="review.name">
                </div>
                <div class="review-content">
                  <h4>{{ review.name }}</h4>
                  <p>"{{ review.content }}"</p>
                </div>
              </div>
            </div>
            
            <!-- 第四行 -->
            <div class="reviews-row reviews-row-4" ref="reviewsRow4">
              <div class="review-item" v-for="(review, index) in getRowReviews(3)" :key="`row4-${index}`">
                <div class="review-avatar">
                  <img :src="getAvatarImage(index + 24)" :alt="review.name">
                </div>
                <div class="review-content">
                  <h4>{{ review.name }}</h4>
                  <p>"{{ review.content }}"</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script> 
export default {
    name: 'rollingBarrage',
    data() {
        return {
         
        }
    },
    computed: {
		reviews() {
			return this.$t('solutions.customerReviews.reviews') || [];
		}
	},
    methods: {
       getRowReviews(rowIndex) {
			const totalReviews = this.reviews.length;
			const baseItemsPerRow = Math.floor(totalReviews / 4); // 基础每行数据条数
			const extraItems = totalReviews % 4; // 余数

			// 前面的行多分配一条数据，确保平均分配
			const itemsPerRow = rowIndex < extraItems ? baseItemsPerRow + 1 : baseItemsPerRow;

			// 计算当前行的起始索引
			let startIndex = 0;
			for (let i = 0; i < rowIndex; i++) {
				startIndex += i < extraItems ? baseItemsPerRow + 1 : baseItemsPerRow;
			}

			const rowReviews = this.reviews.slice(startIndex, startIndex + itemsPerRow);

			// 复制数据以实现无限滚动
			return [...rowReviews, ...rowReviews, ...rowReviews];
		},
		getAvatarImage(index) {
			const avatarIndex = (index % 3) + 1;
			return require(`@/assets/about/team-${avatarIndex}.png`);
		}
    },
}

</script>
<style scoped>
.rollingBarrage{
    width: 100%;
    height: 100%;
}
.reviews-container {
	width: 100%;
	overflow: hidden;
	position: relative;
}

.reviews-scroll-wrapper {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	height: auto;
}

.reviews-row {
	display: flex;
	gap: 1.5rem;
	width: max-content;
	animation: scrollLeft 120s linear infinite;
	height: 80px;
}

.reviews-row-1 {
	animation: scrollLeft 100s linear infinite;
}

.reviews-row-2 {
	animation: scrollLeft 110s linear infinite;
}

.reviews-row-3 {
	animation: scrollLeft 120s linear infinite;
}

.reviews-row-4 {
	animation: scrollLeft 130s linear infinite;
}

.reviews-row:hover {
	animation-play-state: paused;
}
@keyframes scrollLeft {
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(-100%);
  }
}

.review-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: #FFFFFF;
  padding: 0.8rem 1.2rem;
  border-radius: 25px;
  box-shadow: 0px 4px 15px 0px rgba(210,210,210,0.15);
  white-space: nowrap;
  flex-shrink: 0;
  height: 60px;
  max-width: fit-content;
  min-width: fit-content;
}

/* 交替的背景颜色 */
.review-item:nth-child(2n) {
  background: #FFF8F0;
}

.review-item:nth-child(3n) {
  background: #F0F8FF;
}

.review-item:nth-child(4n) {
  background: #F8FFF8;
}

.review-item:nth-child(5n) {
  background: #FFF0F8;
}

.review-item:nth-child(6n) {
  background: #F0FFF0;
}

.review-item:nth-child(7n) {
  background: #FFFACD;
}

.review-item:nth-child(8n) {
  background: #F5F5DC;
}

.review-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.review-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.review-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex-shrink: 0;
}

.review-content h4 {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1E1E1E;
  margin: 0 0 0.2rem 0;
  line-height: 1.2;
  white-space: nowrap;
}

.review-content p {
  font-size: 0.8rem;
  color: #666;
  line-height: 1.3;
  margin: 0;
  white-space: nowrap;
  overflow: visible;
}
</style>